import { render, staticRenderFns } from "./BlockSlideshowUser.vue?vue&type=template&id=81d72904&"
import script from "./BlockSlideshowUser.vue?vue&type=script&lang=js&"
export * from "./BlockSlideshowUser.vue?vue&type=script&lang=js&"
import style0 from "./BlockSlideshowUser.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports